export const DEFAULT_DONUT_ICONS = [
  "https://p1.aprimocdn.net/solarwinds/d3326426-9c14-456c-bf9c-b234015302c8/2305_SWI_Icon_8.%20Observability%20Platform_Original%20file.svg",
  "https://p1.aprimocdn.net/solarwinds/65584d88-926c-4f21-a77e-b2340153249e/2305_SWI_Icon_3.%20Database%20Management_Original%20file.svg",
  "https://p1.aprimocdn.net/solarwinds/6beb360c-c03a-4008-b751-b2a0011ff2db/Icon_-_incident_response_Original%20file.svg",
  "https://p1.aprimocdn.net/solarwinds/64e33dd6-24f6-453b-973b-b23401530e6f/2305_SWI_Icon_5.%20IT%20Service%20Management_Original%20file.svg",
];

export const DEFAULT_DONUT_ICON_STYLES = {
  width: "67px",
  transform: "perspective(600px) rotateX(45deg) rotateY(-15deg)",
  filter: "invert(1) brightness(1000%)",
};
